import {LineChart} from '@crema/modules/thirdParty';
export default LineChart;
